import type { IValidatorDto, IValidatorResult } from "@/types/FormEngine/validation";
import { t, ts } from "../Translation/t";

export default {
  required: (data: IValidatorDto): IValidatorResult => {
    if (data.control.getValue() === undefined) {
      console.warn("Control getValue() function result is undefined ! Please contact developer => ", data.control);
    }
    let validity = true;
    let message = t("required", "_validation");
    if (data.control.state.required) {
      let value = data.control.getValue();

      switch (data.control.mtdt.LDT.FieldType) {
        case "Date": {
          validity = value !== null && value !== "--" && value.length > 3;
          break;
        }
        case "CheckBox": {
          validity = value === "" ? true : value;
          break;
        }
        case "Table": {
          validity = !!value && data.control.state.rows.length > 0;
          break;
        }
        default: {
          validity = value !== null && value !== "" && (typeof value === "number" ? value.toString().length : value.length) > 0;
          break;
        }
      }
    }
    return {
      isValid: validity,
      message: message,
      navigationData: JSON.stringify(data.control.getNavigationData()),
    };
  },
  minRows: (data: IValidatorDto): IValidatorResult => {
    let value = data.control.getValue();
    let validity = true;
    validity = !!value && data.control.state.rows.length >= data.control.mtdt.LDT.MinRows;
    //console.log(validity);
    return {
      isValid: validity,
      message: t("minRows", "_validation", [data.control.mtdt.LDT.MinRows]),
      navigationData: JSON.stringify(data.control.getNavigationData()),
    };
  },
  maxRows: (data: IValidatorDto): IValidatorResult => {
    let validity = true;
    validity = data.control.state.rows.length <= data.control.mtdt.LDT.MaxRows;
    return {
      isValid: validity,
      message: t("maxRows", "_validation", [data.control.mtdt.LDT.MaxRows]),
      navigationData: JSON.stringify(data.control.getNavigationData()),
    };
  },
  tableRows: (data: IValidatorDto): IValidatorResult | Array<IValidatorResult> => {
    // console.log("Table rows validation => ", data);
    let results = new Array<IValidatorResult>();
    if (data.control.state.value && data.control.state.value.length > 0) {
      for (let rowIndex in data.control.state.rows) {
        let row = data.control.state.rows[rowIndex];
        let rowValid = true;
        data.control.setCurrentRow(row.rowNumber, true);
        //console.log(row.rowNumber);
        window.FormEngine.form.walkTreeWith(data.control.config.detail.Tree, function (cont: any) {
          //console.log(cont.identifier,cont.state.hidden)
          if (!cont.state.hidden) {
            let validResults = cont.validate(false, false);
            for (let res of validResults) {
              if (!res.navigationData) res.navigationData = JSON.stringify(res.control.getNavigationData());
              results.push(res);
              if (!res.isValid) {
                rowValid = false;
              }
            }
          }
        });
        //console.log(data.control.state.value,results);
        row.valid = rowValid;
        if (!rowValid) {
          results.push({
            isValid: rowValid,
            control: data.control,
            targetId: data.control.identifier,
            message: t("tableRows", "_validation", [data.control.t("Name", data.control.identifier), row.rowNumber]),
            validatorGuid: data._validatorObject.guid,
            navigationData: JSON.stringify(data.control.getNavigationData()),
          });
        } else {
          results.push({
            isValid: true,
            control: data.control,
            targetId: data.control.identifier,
            message: t("tableRows", "_validation", [data.control.t("Name", data.control.identifier), row.rowNumber]),
            validatorGuid: data._validatorObject.guid,
            navigationData: JSON.stringify(data.control.getNavigationData()),
          });
        }
        data.control.resetDetailView();
      }
    } else {
      results.push({
        isValid: true,
        targetId: data.control.identifier,
        control: data.control,
        message: "Table has no value to be validated.",
        validatorGuid: data._validatorObject.guid,
        navigationData: JSON.stringify(data.control.getNavigationData()),
       //emptyErrors : true,
      });
    }
    //console.log(results);
    return results;
  },
  minLength: (data: IValidatorDto): IValidatorResult => {
    let value = data.control.getValue();
    let validity = true;
    if (data.control.state.required) {
      switch (data.control.mtdt.LDT.FieldType) {
        case "CheckBox": {
          validity = true;
          break;
        }
        default: {
          validity = value ? (typeof value === "number" ? value.toString().length : value.length) >= data.control.mtdt.LDT.MinLength : false;
          break;
        }
      }
    }
    return {
      isValid: validity,
      message: t("minLength", "_validation", [data.control.mtdt.LDT.MinLength]),
      navigationData: JSON.stringify(data.control.getNavigationData()),
    };
  },
  maxLength: (data: IValidatorDto): IValidatorResult => {
    let value = data.control.getValue();
    let validity = true;
    switch (data.control.mtdt.LDT.FieldType) {
      case "CheckBox": {
        validity = true;
        break;
      }
      default: {
        validity = value ? (typeof value === "number" ? value.toString().length : value.length) <= data.control.mtdt.LDT.MaxLength : true;
        break;
      }
    }
    return {
      isValid: validity,
      message: t("maxLength", "_validation", [data.control.mtdt.LDT.MaxLength]),
      navigationData: JSON.stringify(data.control.getNavigationData()),
    };
  },
  regex: (data: IValidatorDto): IValidatorResult => {
    let regexp = new RegExp(data.control.mtdt.LDT.RegularExpression);
    let val = data.control.getValue();
    let validity = true;
    if (val && !regexp.test(val)) {
      validity = false;
    }
    return {
      isValid: validity,
      message: data.control.mtdt.LDT.ErrorMsgRegex
        ? ts(data.control.mtdt.LDT.ErrorMsgRegex, [data.control.mtdt.Name])
        : t("regex", "_validation", [data.control.mtdt.Name]),
      navigationData: JSON.stringify(data.control.getNavigationData()),
    };
  },
  minDate: (data: IValidatorDto): IValidatorResult => {
    let validity = false;
    const year: number = Number(data.control.inputValues.year);
    const month: number = Number(data.control.inputValues.month);
    const day: number = Number(data.control.inputValues.day);
    const dataMinDate: any = data.control.mtdt.LDT.MinDate;

    // If value is not empty. When date is not in valid format, getValue() return empty string.
    if (data.control.getValue() !== null && data.control.getValue() !== "" && data.control.getValue().length > 0) {
      const minDate = new Date(dataMinDate.year, dataMinDate.month - 1, dataMinDate.day);
      const date = new Date(year, month - 1, day);

      // Check if date is less or equal to minDate
      if (minDate <= date) {
        validity = true;
      }
    }

    // Format date for error message
    const defaultFormat = window.FormEngine.engineConfig.builder.components?.Date?.defaultFormat;
    const formattedMinDate = defaultFormat
      ? defaultFormat(dataMinDate.year, dataMinDate.month, dataMinDate.day)
      : data.control.formatDate(dataMinDate.year, dataMinDate.month, dataMinDate.day);

    return {
      isValid: validity,
      message: t("minDate", "_validation", [formattedMinDate]),
      navigationData: JSON.stringify(data.control.getNavigationData()),
    };
  },
  maxDate: (data: IValidatorDto): IValidatorResult => {
    let validity = false;
    const year: number = Number(data.control.inputValues.year);
    const month: number = Number(data.control.inputValues.month);
    const day: number = Number(data.control.inputValues.day);
    const dataMaxDate: any = data.control.mtdt.LDT.MaxDate;

    // If value is not empty. When date is not in valid format, getValue() return empty string.
    if (data.control.getValue() !== null && data.control.getValue() !== "" && data.control.getValue().length > 0) {
      const maxDate = new Date(dataMaxDate.year, dataMaxDate.month - 1, dataMaxDate.day);
      const date = new Date(year, month - 1, day);

      // Check if date is less or equal to maxDate
      if (maxDate >= date) {
        validity = true;
      }
    }

    // Format date for error message
    const defaultFormat = window.FormEngine.engineConfig.builder.components?.Date?.defaultFormat;
    const formattedMaxDate = defaultFormat
      ? defaultFormat(dataMaxDate.year, dataMaxDate.month, dataMaxDate.day)
      : data.control.formatDate(dataMaxDate.year, dataMaxDate.month, dataMaxDate.day);

    return {
      isValid: validity,
      message: t("maxDate", "_validation", [formattedMaxDate]),
      navigationData: JSON.stringify(data.control.getNavigationData()),
    };
  },
  minCount: (data: IValidatorDto): IValidatorResult => {
    let minCountValue = data.control.mtdt.LDT.MinCount;
    let value = data.control.getValue();
    const numericRegex = /^\d+$/;
    let validity = false;

    // If is string from TextBox integer
    if (!(!value || !numericRegex.test(value))) {
      validity = Number(value) >= minCountValue;
    }

    return {
      isValid: validity && data.control.getValue() !== null && data.control.getValue() !== "" && data.control.getValue().length > 0,
      message: t("minCount", "_validation", [minCountValue]),
      navigationData: JSON.stringify(data.control.getNavigationData()),
    };
  },
  maxCount: (data: IValidatorDto): IValidatorResult => {
    let maxCountValue = data.control.mtdt.LDT.MaxCount;
    let value = data.control.getValue();
    const numericRegex = /^\d+$/;
    let validity = false;

    // If is string from TextBox integer
    if (!(!value || !numericRegex.test(value))) {
      validity = Number(value) <= maxCountValue;
    }

    return {
      isValid: validity && data.control.getValue() !== null && data.control.getValue() !== "" && data.control.getValue().length > 0,
      message: t("maxCount", "_validation", [maxCountValue]),
      navigationData: JSON.stringify(data.control.getNavigationData()),
    };
  },
};
